//  This function is loading custom asset types to grapesJs
const LoadAssetTypes = (editor) => {

    editor.on("load", () => { 

        // Get the Asset Manager module first
        const am = editor.AssetManager;

        //  Custom already defined image asset type to have internal info message
        am.addType('image', {
            view: {
                getInfo() {
                    return '<div>Click here to select the image</div>';
              },
            },
          })

    })

}

export default LoadAssetTypes;